import { useCallback, useEffect, useState } from 'react';
import { workflowService } from '../api/workflowService';
import type { ApprovalInboxItem } from '../api/types';

export const useApprovalInbox = () => {
  const [data, setData] = useState<ApprovalInboxItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setData(await workflowService.approvalInbox());
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { data, loading, error, refetch: fetch };
};
